import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { OrganizationService } from '../services/organization.service';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ClientService } from '../services/client.service';
import { OrganizationInterface } from '../interfaces/organization.interface';
import { ClientInterface } from '../interfaces/client.interface';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable, of, startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import {SidenavService} from "../services/sidenav.service";
import {SettingsService} from "../services/settings.service";

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [
    MatButtonModule,
    MatInputModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  providers: [HttpClient],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent implements OnInit {

  snackbarService: MatSnackBar = inject(MatSnackBar)

  organizationGroup = new FormGroup({
    name: new FormControl(),
    contact_manager_name: new FormControl(),
    contact_manager_phone: new FormControl(),
    contact_manager_email: new FormControl(),
    ipAddress: new FormControl(),
    address: new FormControl(),
    internalIp: new FormControl(),
    license_server_auth_token: new FormControl(),
  })

  userGroup = new FormGroup({
    organization: new FormControl(),
    user_fio: new FormControl(),
    login: new FormControl(),
    password: new FormControl(),
    email: new FormControl(),
  })

  options: OrganizationInterface[] = [];

  filteredOptions: Observable<OrganizationInterface[]> = of([]);


  constructor(
    public organizationService: OrganizationService,
    public clientService: ClientService,
    public sidenavService: SidenavService,
    public settingsService: SettingsService,
  ) {
  }

  ngOnInit() {
    this.valueChangesOrganizationSubscribe();
    this.loadOrganizationList();
  }

  loadOrganizationList() {
    this.organizationService.loadOrganizationList()
      .subscribe((res) => {
        this.options = res;
      })
  }

  valueChangesOrganizationSubscribe() {
    this.filteredOptions = this.userGroup.controls.organization.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.options.slice();
      }),
    );
  }

  displayFn(organization: OrganizationInterface): string {
    return organization && organization.name ? organization.name : '';
  }

  private _filter(name: string): OrganizationInterface[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }


  createOrganization() {
    const org = this.organizationGroup.value;
    this.organizationService.createOrganization(org as OrganizationInterface)
      .subscribe((res) => {
        this.loadOrganizationList();
        this.organizationGroup.reset();
        this.snackbarService.open('Success!', 'close', {duration: 3000})
        this.sidenavService.sideNavState$.next(false);
        this.settingsService.updateList$.next(true);
      })
  }

  createClient() {
    this.clientService.createClient(this.userGroup.value as ClientInterface)
      .subscribe((res) => {
        console.log('user create', res);
        if(res.error){
          alert(res.message)
        } else {
          this.userGroup.reset()
          this.snackbarService.open('Success!', 'close', {duration: 3000})
        }
      })
  }


}
